<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500"
      >
        List of Uploaded Sku
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="orderList"
      :options.sync="options"
      :server-items-length="total"
      :loading="orderListLoader"
      class="elevation-1 custom-icon-size"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.modified`]="{ item }">
        {{ item.modified | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:[`item.duty_handling`]="{ item }">
        {{ item.duty_handling ? item.duty_handling.toUpperCase() : "" }}
      </template>

      <template v-slot:[`item.upload_type`]="{ item }">
        {{ item.uploaded_type ? item.uploaded_type : uploaded_type }}
      </template>
      <template v-slot:[`item.created`]="{ item }">
        {{ item.created | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:[`item.excel_file_complete`]="{ item }">
        <v-icon
          @click="download(item.excel_file_complete)"
          small
          v-if="
            item.status !== 'Pending' &&
            item.status !== 'In Processing' &&
            item.status !== 'Failed'
          "
        >
          mdi-file
        </v-icon>
      </template>
      <template v-slot:[`item.excel_file_uploaded`]="{ item }">
        <v-icon
          @click="download(item.excel_file_uploaded)"
          small
          v-if="item.excel_file_uploaded !== null"
        >
          mdi-file
        </v-icon>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <a @click="open(item)" v-if="item.status !== 'Not started'">{{
          item.status
        }}</a>

        <span v-else>{{ item.status }}</span>
      </template>
    </v-data-table>
    <v-dialog
      v-model="syncMessage"
      max-width="650px"
      scrollable
      close-delay="ma-5"
      @keydown.esc="
        syncMessage = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              syncMessage = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="details"
            :items="detailsData"
            class="elevation-1 mt-7"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :items-per-page="25"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="propName == 'product_upload'"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    {{ item }}
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="openMessage"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessage = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessage = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="_detailsHeaders"
            :items="detailsData"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.ordercode`]="{ item }"
              v-if="propName == 'package_upload'"
            >
              {{ item.order_reference }}
            </template>
            <template
              v-slot:[`item.tracking_no`]="{ item }"
              v-if="propName == 'package_upload'"
            >
              {{ item.message.tracking_no }}
            </template>
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="propName == 'package_upload'"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    {{ item }}
                  </li>
                </ul>
              </span>
            </template>
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="propName == 'order_upload'"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item.message }}</b>
                    <br />{{ item.description }}
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="openMessageProduct"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessageProduct = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessageProduct = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="productHeaders"
            :items="detailsData"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="detailsData !== null"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item.message }}</b>
                    <br />{{ item.description }}
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="failedCountPopUp"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        failedCountPopUp = false;
        failedData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon @click="failedCountPopUp = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="failedHeaders"
            :items="failedData"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetailsFailed"
            :server-items-length="failedtotals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="openSkuBarcode"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openSkuBarcode = false;
        skuArray = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon @click="openSkuBarcode = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="barcodeHeaders"
            :items="skuArray"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="failedCountPopUpSKu"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        failedCountPopUpSKu = false;
        failedDataSku = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon @click="failedCountPopUpSKu = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="failedHeadersSku"
            :items="failedDataSku"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetailsFailed"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template v-slot:[`item.errors`]="{ item }">
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item }}</b>
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="loader-wrapper" v-if="isloading">
      <div class="loader"></div>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},

  computed: {
    ...mapGetters(["userRole", "userCategory"]),
  },
  props: {
    propName: String, // Declare the prop with its expected type
  },
  data: () => ({
    uploaded_type: "B2B SKU Upload",
    isloading: false,
    failedData: [],
    productsData: [],
    openMessageProduct: false,
    type: null,
    totals: 0,
    failedtotals: 0,
    optionsDetailsFailed: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    optionsDetails: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    syncMessage: false,
    openMessage: false,
    openMessageInbound: false,
    openMessageVariant: false,
    detailsHeaders: [
      {
        text: "Order #",
        value: "ordercode",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Tracking No.",
        value: "tracking_no",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Warning",
        value: "warnings",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Result",
        value: "result",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    failedHeaders: [
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Error Reason",
        value: "error_reason",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    failedoutboundHeaders: [
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],

    details: [
      {
        text: "Code",
        value: "product_code",
        class: "body-1 font-weight-bold",
        align: "left",
      },
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
      },
      {
        text: "Warning",
        value: "warnings",
        class: "body-1 font-weight-bold",
        align: "left",
      },
      {
        text: "Result",
        value: "result",
        class: "body-1 font-weight-bold",
        align: "left",
      },
    ],
    headers: [
      {
        text: "Client Name",
        value: "client_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Type of Upload",
        value: "upload_type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Uploaded By",
        value: "upload_by",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Created At",
        value: "created",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Uploaded File",
        value: "excel_file_uploaded",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Total Count",
        value: "total_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Processed Count",
        value: "updated_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Failed Count",
        value: "failed_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Success Count",
        value: "success_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Processed Date",
        value: "modified",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    options: {},
    total: 0,
    orderList: [],
    orderListLoader: false,
    detailsData: [],
    dropdownSelected: false,
    newArray: [],
    previousNumber: 25,
    loadingItems: {},
    newArrayBulk: [],
    openSkuBarcode: false,
    barcodeHeaders: [
      {
        text: "B2B SKU",
        value: "b2b_sku_id",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Barcode",
        value: "barcode",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    skuArray: [],
    openMessageVariantOutbound: false,
    failedCountPopUpSKu: false,
    failedHeadersSku: [
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Error Reason",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        if (this.propName !== "sku_sync" && this.propName !== "sku_mapping") {
          this.fetchOrderList();
        }
        if (this.dropdownSelected == true) {
          this.fetchOrderList();
        }
      },
      deep: true,
    },

    optionsDetails: {
      handler() {
        this.open(this.item);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getOrderList",
      "downloadOrderFile",
      "getMessageRes",
      "manualTriger",
      "snackBar",
      "getOrderListBulk",
    ]),
    async openFailedCount(item) {
      this.faileditem = item;
      this.failedData = [];
      var type;
      if (this.propName == "inbound_upload") {
        type = "inbound";
      } else if (this.propName == "outbound_upload") {
        type = "outbound";
      } else if (this.propName == "inbound_variant_upload") {
        type = "inbound_variant_upload";
      } else if (this.propName == "outbound_variant_upload") {
        type = "outbound_variant_upload";
      }

      let data = {
        excel_id: this.faileditem.id,
        b2b_upload: type,
      };
      await this.getMessageRes({ ...data, ...this.optionsDetailsFailed }).then(
        (res) => {
          this.failedData = res.data.records;

          this.failedtotals = res.data.total;
          this.failedCountPopUp = true;
          if (this.failedData == null || this.failedData == undefined) {
            this.failedData = [];
          }
        }
      );
    },
    async open(item) {
      this.item = item;
      window.open(
        this.$router.resolve({
          name: "SkuErrorlist",
          query: {
            excel_id: this.item.id,
          },
        }).href,
        "_blank"
      );
    },

    async handleClick(item) {
      this.isloading = true;
      this.$set(this.loadingItems, item.id, true); // Set loading state for the specific item
      try {
        await this.tryAgain(item); // Assume this is an async function
      } finally {
        this.$set(this.loadingItems, item.id, false); // Reset loading state for the item
      }
    },
    async tryAgain(item) {
      let data = {
        excel_id: item.id,
      };
      await this.manualTriger(data).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.data.message,
        });
        this.isloading = false;

        this.fetchOrderList();
      });
    },
    fetchOrderList() {
      this.orderList = [];
      this.orderListLoader = true;
      this.getOrderList({
        ...this.options,
        ...this.filtersArr,
        type: "b2b_sku_upload",
      })
        .then((res) => {
          this.orderListLoader = false;
          this.orderList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.orderListLoader = false;
        });
    },
    download(url) {
      url = `/api/file_download?file_path=${url}`;

      this.downloadOrderFile(url)
        .then((res) => {
          this.fileDownload(res);
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.custom .v-text-field__details {
  display: none;
}
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loader appears on top of other content */
}
.loader-wrapper.active {
  display: flex;
}

.content {
  display: none;
}

.loader-wrapper.active + .content {
  display: block;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Add a spinning animation */
}
/* Animation keyframes for the loader */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
